// @flow
import typeToReducer from 'type-to-reducer'
import { normalize } from 'normalizr'

import type { Language } from '@alphaott/api-client/types/languages'
import type { LanguageNormalize } from '@alphaott/common-types/normalized'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import { languagesListSchema } from '@alphaott/common-utils/utils/schemas/languages'
import { defaultToEmptyObject } from '@alphaott/common-utils/utils/help'
import { FETCH_MOVIE_LANGUAGES_TYPE } from '../../actions/languages'

export type MovieLanguagesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Language>,
  +entities: LanguageNormalize,
  +expires: ?number,
}

const initialState: MovieLanguagesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  entities: {},
  expires: null,
}

const movieLanguages = typeToReducer(
  {
    [FETCH_MOVIE_LANGUAGES_TYPE]: {
      LOADING: (state): MovieLanguagesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): MovieLanguagesState => {
        const {
          payload,
          meta: { ttl },
        } = action
        const { entities } = normalize(payload.data, languagesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: payload.data,
          entities: defaultToEmptyObject(entities.languages),
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): MovieLanguagesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { movieLanguages }
